import { escapeHtml } from '../utils/html_utils.js?v=20260706d';

function closeDialog(root, resolve, value) {
  root.remove();
  resolve(value);
}

function openTextPromptDialog(options = {}) {
  return new Promise(resolve => {
    const root = document.createElement('div');
    root.className = 'modal-backdrop auth-modal-root';
    root.innerHTML = `
      <form class="modal auth-modal confirm-modal" data-dialog-form>
        <div class="modal-title">${escapeHtml(options.title || 'Eingabe')}</div>
        ${options.message ? `<div class="note">${escapeHtml(options.message)}</div>` : ''}
        <label>
          <span>${escapeHtml(options.label || 'Wert')}</span>
          <input name="dialogValue" type="text" autocomplete="off" value="${escapeHtml(options.initialValue || '')}">
        </label>
        <div class="confirm-actions">
          <button type="button" class="btn" data-dialog-cancel>Abbrechen</button>
          <button type="submit" class="btn primary">${escapeHtml(options.confirmLabel || 'OK')}</button>
        </div>
      </form>
    `;

    root.addEventListener('click', event => {
      if (event.target.closest('[data-dialog-cancel]')) {
        closeDialog(root, resolve, null);
      }
    });
    root.querySelector('[data-dialog-form]')?.addEventListener('submit', event => {
      event.preventDefault();
      closeDialog(root, resolve, root.querySelector('input[name="dialogValue"]')?.value ?? '');
    });

    document.body.appendChild(root);
    root.querySelector('input[name="dialogValue"]')?.focus();
    root.querySelector('input[name="dialogValue"]')?.select();
  });
}

function openConfirmDialog(options = {}) {
  return new Promise(resolve => {
    const root = document.createElement('div');
    root.className = 'modal-backdrop auth-modal-root';
    root.innerHTML = `
      <div class="modal confirm-modal" role="dialog" aria-modal="true" aria-label="${escapeHtml(options.title || 'Bestätigen')}">
        <div class="modal-title">${escapeHtml(options.title || 'Bestätigen')}</div>
        <div class="note">${escapeHtml(options.message || 'Diese Aktion wirklich ausführen?')}</div>
        <div class="confirm-actions">
          <button type="button" class="btn" data-dialog-cancel>${escapeHtml(options.cancelLabel || 'Abbrechen')}</button>
          <button type="button" class="btn ${options.danger ? 'danger' : 'primary'}" data-dialog-confirm>${escapeHtml(options.confirmLabel || 'OK')}</button>
        </div>
      </div>
    `;

    root.addEventListener('click', event => {
      if (event.target.closest('[data-dialog-cancel]')) {
        closeDialog(root, resolve, false);
      }
      if (event.target.closest('[data-dialog-confirm]')) {
        closeDialog(root, resolve, true);
      }
    });
    document.body.appendChild(root);
    root.querySelector('[data-dialog-cancel]')?.focus();
  });
}

function openChoiceDialog(options = {}) {
  return new Promise(resolve => {
    const choices = Array.isArray(options.choices) && options.choices.length
      ? options.choices
      : [
        { value: 'cancel', label: 'Abbrechen' },
        { value: 'ok', label: 'OK', className: 'primary' }
      ];
    const defaultValue = Object.prototype.hasOwnProperty.call(options, 'defaultValue')
      ? options.defaultValue
      : choices[0]?.value ?? null;
    const root = document.createElement('div');
    root.className = 'modal-backdrop auth-modal-root';
    root.innerHTML = `
      <div class="modal confirm-modal" role="dialog" aria-modal="true" aria-label="${escapeHtml(options.title || 'Auswahl')}">
        <div class="modal-title">${escapeHtml(options.title || 'Auswahl')}</div>
        <div class="note">${escapeHtml(options.message || '')}</div>
        <div class="confirm-actions">
          ${choices.map((choice, index) => `
            <button
              type="button"
              class="btn ${escapeHtml(choice.className || '')}"
              data-dialog-choice="${index}"
            >${escapeHtml(choice.label || String(choice.value ?? ''))}</button>
          `).join('')}
        </div>
      </div>
    `;

    root.addEventListener('click', event => {
      const choiceButton = event.target.closest('[data-dialog-choice]');
      if (!choiceButton) return;
      const choice = choices[Number(choiceButton.dataset.dialogChoice)];
      closeDialog(root, resolve, choice?.value ?? defaultValue);
    });
    document.body.appendChild(root);
    const focusIndex = choices.findIndex(choice => choice.autofocus === true);
    root.querySelector(`[data-dialog-choice="${focusIndex >= 0 ? focusIndex : 0}"]`)?.focus();
  });
}

export {
  openConfirmDialog,
  openChoiceDialog,
  openTextPromptDialog
};
